module.exports = "<li class=match-visible data-id=\"'{{id}}'\" data-name=\"'{{name}}'\" data-py=\"'{{py}}'\"> <label class=custom-checkbox> <div> <input type=checkbox class=checkbox name=\"\" data-id=\"'{{id}}'\" value=\"'{{id}}'\" data-name=\"'{{name}}'\"/> </div> <span class=my-select-span title={{name}}> {{#if isSetColor}} <span class=set-color></span> {{/if}} {{name}} </span> </label> </li>";


//////////////////
// WEBPACK FOOTER
// ./app/components/util/autoSelect/autoSelectedItem/autoSelectedItem.html
// module id = 1946
// module chunks = 50